import React, { useState } from "react";
import i18n from "utils/i18n";
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import Translate from 'utils/translate'
import { GraphBookingPresenceDayChart } from 'components/management/molecules/graphs'
import ThemedBlockTitle from "components/atoms/ThemedBlockTitle";
import { styles } from "scenes/management/dashboard/components/buildingMeetingRooms";
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ManagementDashboardModalMeetingRoomDetails from "scenes/management/dashboard/modals/buildingPresenceList";
import Text from "theme/Text";
import GraphCheckinTimeGrow from 'components/management/molecules/GraphCheckinTimeGrow'
import ThemedPressable from 'components/atoms/ThemedPressable'
import { ManagementDashboardComponentBuildingStyles } from 'styles/scenes/management/dashboard/components/BuildingStyles'
import HelperDate, { dateFormat } from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'

const ManagementDashboardComponentBuilding =  ( { building = null } ) => {
	const [ showModal, setShowModal ] = useState( false );

	let today = [ HelperDate.date().format( dateFormat.DATE ), HelperDate.date().format( dateFormat.DATE ) ];

	return (
		<VStack>
			{ showModal && (
				<ManagementDashboardModalMeetingRoomDetails building={ building } onClose={ () => {
					return setShowModal(false);
				} } />
			)}

			<Grid>
				<Container>
					<Row style={ ManagementDashboardComponentBuildingStyles.row } justify={'flex-start'} align={'center'}>
						<Column auto>
							<ThemedBlockTitle style={ ManagementDashboardComponentBuildingStyles.rowTitle }>
								{ i18n.t( 'management:pages.dashboard.titles.statistics', { name: Translate.field( building, 'title' ) } ) }
							</ThemedBlockTitle>
						</Column>
						<Column auto>
							{ HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.PRESENCE ) && (
								<ThemedPressable onPress={ setShowModal.bind( this, true ) }>
									<Text style={styles.textShowAllTimeSlots}>{  i18n.t( 'management:pages.dashboard.building.show_all_present' ) }</Text>
								</ThemedPressable>
							)}
						</Column>
					</Row>
					
					<Row
						style={ ManagementDashboardComponentBuildingStyles.row }
						justify={'flex-start'}
						align={'center'}
						chunk={{ xs: 1, md: 2 }}>
						
						<Column>
							<GraphCheckinTimeGrow
								dateRange={ today }
								liveToday
								building={[
									building.guid
								]}
							/>
						</Column>
						<Column>
							<GraphBookingPresenceDayChart
								dateRange={ today }
								liveToday
								building={[
									building.guid
								]}
							/>
						</Column>
					</Row>
				</Container>
			</Grid>
		</VStack>
	);
}

export default ManagementDashboardComponentBuilding
